import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiStatsV2WorkrecordDailyElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiStatsV2WorkrecordDailyElFindParams, unknown>

const fetchStatsWorkRecordDaily = async (params: ApiStatsV2WorkrecordDailyElFindParams) => {
  const { data } = await apiClient.v2.apiStatsV2WorkrecordDailyElFind(params);
  return checkApiResponse(data);
}

export const statsWorkRecordDailyKeys = {
  all: [QUERY_KEY.v2apiStatsV2WorkrecordDailyElFind] as const,
  list: (params: ApiStatsV2WorkrecordDailyElFindParams) => [...statsWorkRecordDailyKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(statsV2WorkRecordDailyFindQueryOptions(params))` */
export const statsV2WorkRecordDailyFindQueryOptions = (params: ApiStatsV2WorkrecordDailyElFindParams) => ({
  queryKey: statsWorkRecordDailyKeys.list(params),
  queryFn: () => fetchStatsWorkRecordDaily(params),
})

export const useStatsV2WorkRecordDailyFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: statsWorkRecordDailyKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchStatsWorkRecordDaily(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
